"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleModeUp = void 0;
var toggleModeUp = function (utils) {
    var a11yHasExpectedHtml = utils.a11yHasExpectedHtml, hasReturnVal = utils.hasReturnVal, loadPrimaryInput = utils.loadPrimaryInput, use = utils.use;
    describe('Mode - UP toggle', function () {
        it('UP Updates mode correctly', function () {
            loadPrimaryInput({ segment: 'mode' })
                .then(use.upArrow)
                .should('have.value', '08:30 AM')
                .then(a11yHasExpectedHtml("<p>AM.</p>"))
                .then(hasReturnVal('08:30'));
        });
        it('UP UP Updates mode correctly', function () {
            loadPrimaryInput({ segment: 'mode' })
                .then(use.upArrow)
                .then(use.upArrow)
                .should('have.value', '08:30 PM')
                .then(a11yHasExpectedHtml("<p>PM.</p>"))
                .then(hasReturnVal('20:30'));
        });
        it('UP DOWN Updates mode correctly', function () {
            loadPrimaryInput({ segment: 'mode' })
                .then(use.upArrow)
                .then(use.upArrow)
                .should('have.value', '08:30 PM')
                .then(a11yHasExpectedHtml("<p>PM.</p>"))
                .then(hasReturnVal('20:30'));
        });
    });
};
exports.toggleModeUp = toggleModeUp;
